<div class="w-100" [ngClass]="{ 'mat-ng-select': !tableStyle, 'd-flex': tableStyle }">
    <ng-select
        class="entity-input"
        [class.ng-select-fill]="!tableStyle"
        [formControl]="fc"
        placeholder="Inhuur"
        appendTo="body">
        @for (hire of hiring$ | async; track hire.id) {
            <ng-option [value]="hire.id">
                {{ hire.name }}
            </ng-option>
        }
    </ng-select>
</div>
